import type {
  FormBuilder_Locale,
  FormBuilder_ScreenNode_Block,
} from '~/graphql/types';

export const localeToIntlKey: Record<FormBuilder_Locale, string> = {
  NL: 'nl',
  EN: 'en',
};

export const localeToLabel: Record<FormBuilder_Locale, string> = {
  NL: 'Label (🇳🇱)',
  EN: 'Label (🇬🇧)',
};

export const blockLabelMap: {
  [key in FormBuilder_ScreenNode_Block['__typename']]: string;
} = {
  FormData_Input_Email: 'E-mail invoer',
  FormData_Input_Integer: 'Geheel getal invoer',
  FormData_Input_Multiline: 'Meerdere regels invoer',
  FormData_Input_Text: 'Tekst invoer',
  FormData_Select_Dropdown: 'Keuzelijst',
  FormData_Select_MultiButton: 'Multi-knop',
  FormData_Select_Radio: 'Radio',
  FormData_UI_Image: 'Afbeelding',
  FormData_UI_RichText: 'Rijke tekst',
  FormData_UI_Typography: 'Typografie',
};
